document.addEventListener("DOMContentLoaded", function () {
    const sqmInput = document.getElementById("sqmInput");
    const boxInput = document.getElementById("boxInput");
    const wastageCheckbox = document.getElementById("wastageCheckbox");
    const quantitySelector = document.querySelector(".quantity__input");
    const totalPriceElement = document.getElementById("totalPrice");
    const addToCartButton = document.querySelector(".product-form__submit span");
    const stockMessageElement = document.getElementById("stockMessage");
    const shippingMessageElement = document.getElementById("shippingMessage");
    const deliveryNoteElement = document.querySelector(".dc_delivery-note");

    function getSelectedVariant() {
        return document.querySelector(".button-input__input:checked, select option:checked");
    }

    function getSelectedVariantM2PerBox() {
        const selectedOption = getSelectedVariant();
        return selectedOption ? parseFloat(selectedOption.dataset.packM2) || 1 : 1;
    }

    function getSelectedVariantPrice() {
        const selectedOption = getSelectedVariant();
        return selectedOption ? parseFloat(selectedOption.dataset.price) || 0 : 0;
    }

    function getSelectedVariantWeight() {
        const selectedOption = getSelectedVariant();
        return selectedOption ? parseFloat(selectedOption.dataset.weight) / 1000 || 0 : 0; // Convert grams to kg
    }

    function getSelectedVariantStock() {
        const selectedOption = getSelectedVariant();
        if (!selectedOption) return { available: 0 };
        return { available: parseInt(selectedOption.dataset.inventoryQuantity) || 0 };
    }

    function calculateShippingCost() {
        const weightPerBox = getSelectedVariantWeight(); // Already converted to kg
        const boxesRequired = parseInt(boxInput.value) || 0;
        const totalWeight = weightPerBox * boxesRequired;
        const costPer1000kg = 66;
        const shippingCost = Math.ceil(totalWeight / 1000) * costPer1000kg;
        return shippingCost;
    }

    function resetForm() {
        sqmInput.value = '0'; 
        boxInput.value = '0'; 
        wastageCheckbox.checked = false; 
        if (quantitySelector) quantitySelector.value = '0';
        totalPriceElement.textContent = '£0.00';
        stockMessageElement.textContent = 'Enter quantity for delivery time';
        shippingMessageElement.textContent = 'Shipping estimate: ';
        deliveryNoteElement.className = "dc_delivery-note";
        updateAddToCartButton(0, 0);
    }

    function updateTotalPrice() {
        const boxes = parseInt(boxInput.value) || 0;
        const pricePerBox = getSelectedVariantPrice();
        totalPriceElement.textContent = `£${(boxes * pricePerBox).toFixed(2)}`;
        updateAddToCartButton(boxes, boxes * pricePerBox);
    }

    function updateAddToCartButton(boxes, totalPrice) {
        if (addToCartButton) {
            addToCartButton.textContent = boxes > 0 
                ? `ADD TO CART (${boxes}) £${totalPrice.toFixed(2)}` 
                : `ADD TO CART`;
        }
    }

    function updateStockMessage() {
    if (!stockMessageElement || !shippingMessageElement || !deliveryNoteElement) return;

    const variant = getSelectedVariant();
    const stock = getSelectedVariantStock();
    const boxesRequired = parseInt(boxInput.value) || 0;
    const shippingCost = calculateShippingCost();
    deliveryNoteElement.className = "dc_delivery-note";

    // Use the productVendor set by Liquid
    console.log("Product Vendor:", productVendor);  // Debugging

    if (!variant || boxesRequired === 0) {
        stockMessageElement.textContent = 'Enter quantity for shipping estimate';
        shippingMessageElement.textContent = '';
    } else if (boxesRequired <= stock.available) {
        stockMessageElement.textContent = "Shipping estimate: 3-5 business days, ";
        shippingMessageElement.textContent = `£${shippingCost}.`;
        deliveryNoteElement.classList.add("stock-available");
    } else {
        // Apply the stock-limited class only if the vendor is not "UK SUPPLIER"
        if (productVendor === "UK SUPPLIER") {
            stockMessageElement.textContent = "Shipping estimate: 3-5 business days, ";
            deliveryNoteElement.classList.add("stock-available"); // Ensure stock-available is used here
        } else {
            stockMessageElement.textContent = "Shipping estimate: 3-4 weeks, ";
            deliveryNoteElement.classList.add("stock-limited");
        }
        shippingMessageElement.textContent = `£${shippingCost}.`;
    }
}

    function calculateBoxes(applyWastage = true) {
    const sqmPerBox = getSelectedVariantM2PerBox();
    let sqmRequired = parseFloat(sqmInput.value) || 0;

    if (applyWastage && wastageCheckbox.checked) {
        sqmRequired *= 1.1; // Apply 10% wastage
    }

    boxInput.value = Math.ceil(sqmRequired / sqmPerBox);

    if (quantitySelector) {
        quantitySelector.value = boxInput.value;
    }

    updateTotalPrice();
    updateStockMessage();
}

function handleSqmInputChange() {
    // Allow user to type without forcing a reset
    wastageCheckbox.checked = false; // Uncheck wastage checkbox when manually entering sqm
}

function handleWastageChange() {
    if (wastageCheckbox.checked) {
        // Apply 10% wastage
        sqmInput.value = (parseFloat(sqmInput.value) * 1.1).toFixed(2);
    } else {
        // Remove 10% wastage
        sqmInput.value = (parseFloat(sqmInput.value) / 1.1).toFixed(2);
    }
    
    calculateBoxes(false); // Update boxes without modifying sqm again
}

// Event Listeners
sqmInput.addEventListener("input", handleSqmInputChange);
sqmInput.addEventListener("blur", () => calculateBoxes(false)); // Update on blur without resetting
wastageCheckbox.addEventListener("change", handleWastageChange);

  

    function calculateSqm() {
        const sqmPerBox = getSelectedVariantM2PerBox();
        const boxes = parseInt(boxInput.value) || 0;
        sqmInput.value = wastageCheckbox.checked ? (boxes * sqmPerBox / 1.1).toFixed(2) : (boxes * sqmPerBox).toFixed(2);
        if (quantitySelector) quantitySelector.value = boxes;
        updateTotalPrice();
        updateStockMessage();
    }

    function handleQuantityChange() {
        boxInput.value = parseInt(quantitySelector.value) || 0;
        calculateSqm();
    }

    sqmInput.addEventListener("input", calculateBoxes);
    boxInput.addEventListener("input", function() {
        calculateSqm();
        if (quantitySelector) quantitySelector.value = boxInput.value;
    });
    wastageCheckbox.addEventListener("change", calculateBoxes);

    if (quantitySelector) {
        quantitySelector.addEventListener("input", handleQuantityChange);
        quantitySelector.addEventListener("change", handleQuantityChange);
        quantitySelector.addEventListener("blur", handleQuantityChange);
    }

    function handleVariantChange() {
        resetForm();
        calculateBoxes();
        updateStockMessage();
    }

    function watchForVariantChanges() {
        const observer = new MutationObserver(() => {
            document.querySelectorAll(".button-input__input, select").forEach(input => {
                input.removeEventListener("change", handleVariantChange);
                input.addEventListener("change", handleVariantChange);
            });
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    watchForVariantChanges();
    resetForm();
    updateStockMessage();
});